// extracted by mini-css-extract-plugin
module.exports = {"wrap":"userNav_wrap__3qBJa","trigger":"userNav_trigger__g_13h","dark":"userNav_dark__1h7n9","hint":"userNav_hint__1IGDy","dots":"userNav_dots__EMvih","icon":"userNav_icon__1e42N"};